import Button from "@/common/components/Button";
import SelectController from "@/common/components/SelectController";
import { useCompanyUsers } from "@/common/hooks/queries/useCompanyUsers";
import useDebounce from "@/common/hooks/useDebounce";
import { Mapper } from "@/common/services/mapper";
import { EstablishmentUserData } from "@/common/types/establishmentUsers.type";
import { useFormContext, useWatch } from "react-hook-form";
import { useParams } from "react-router-dom";
import { checkinEntryOptions } from "../../../../constants/directiveEntryFormSteps/checkinEntry/checkinEntryOptions.constant";
import { CheckinEntryValidationSchema } from "../../../../schemas/maintenanceForwardingDirectiveSteps.schema";
import { useCreateForwardingsFormStore } from "../../../../stores/createForwardingsFormStore";
import { MaintenanceForwardingCheckinEntryKlass } from "../../../../types/forwardings/checkinEntries/checkinEntry.type";
import CreateForwardingDirectiveEntryFormStepHeader from "../../../CreateForwardingDirectiveEntryFormStepHeader";

const CheckinEntryAutoEntryPending = () => {
  const { companyId } = useParams();

  const { increaseStep } = useCreateForwardingsFormStore();

  const [searchEstablishmentUser, setSearchEstablishmentUser] = useDebounce('');

  const {
    control,
    setValue,
  } = useFormContext<CheckinEntryValidationSchema>();

  const {
    checkin_entry_attributes: watchCheckinEntryAttributes,
  } = useWatch({
    control,
  });

  const watchResponsible = watchCheckinEntryAttributes?.responsible;

  const autoEntryOption = checkinEntryOptions[MaintenanceForwardingCheckinEntryKlass.TransportAutoEntry];

  const {
    data: clientUsersOptions,
    isPending: clientUsersIsPending,
  } = useCompanyUsers({
    filters: {
      companyId,
      search: searchEstablishmentUser,
    },
    mapper: Mapper.mapToOptions<EstablishmentUserData>({
      valueFieldName: 'id',
      labelFieldName: 'full_name',
    }),
  });

  return (
    <div className="flex flex-col gap-4">
      <CreateForwardingDirectiveEntryFormStepHeader
        goBackAction={() => {
          setValue('checkin_entry_type', undefined!);
          setValue('checkin_entry_attributes', undefined!);
        }}
        title={autoEntryOption.title}
        description={autoEntryOption.description}
      />

      <div>
        <SelectController
          control={control}
          name="checkin_entry_attributes.responsible"
          label="Usuário responsável pelo transporte/confirmação de retirada"
          options={clientUsersOptions}
          onInputChange={setSearchEstablishmentUser}
          isLoading={clientUsersIsPending}
          isDisabled={clientUsersIsPending}
        />
      </div>

      <div className="flex items-center justify-end">
        <div className="flex items-center gap-2">
          <Button
            variant="error"
            onClick={() => {
              setValue('checkin_entry_type', undefined!);
              setValue('checkin_entry_attributes', undefined!);
            }}
          >
            Cancelar
          </Button>

          <Button
            disabled={!watchResponsible}
            onClick={increaseStep}
          >
            Confirmar
          </Button>
        </div>
      </div>
    </div>
  );
}

export default CheckinEntryAutoEntryPending;
